module.exports = __webpack_public_path__ + "img/select_date.e798ee1a.svg";